<template>
  <v-list-tile
    avatar
    v-show="activeSearch"
  >
    <v-list-tile-avatar>
      <v-icon color="success">star</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{ title }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ description }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-btn
        icon
        ripple
        :to="{name: 'search-view', params: {id: id}}"
      >
        <v-icon
          color="grey lighten-1"
        >
          settings
        </v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
  import mixinsSearch from '@/mixins/search'

  export default {
    mixins: [mixinsSearch],
    computed: {
      title () {
        return this._.get(this.activeSearch, 'name')
      },
      description () {
        return this.activeSearch ? this.getDescription(this.activeSearch.data) : ''
      },
      id () {
        return this._.get(this.activeSearch, 'id', 0)
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/components/search/ActiveSearch.vue